export const OS_IOS = 'iOS';
export const OS_ANDROID = 'Android';
export const OS_WINDOWSPHONE = 'Windows Phone';
export const OS_UNKNOWN = 'unknown';
// source: https://stackoverflow.com/questions/21741841/detecting-ios-android-operating-system
export const getDeviceOperatingSystem = () => {
    try {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // As Useragent of Windows Phone contains also 'Android', it must come first
        if (/windows phone/i.test(userAgent)) {
            return OS_WINDOWSPHONE;
        }
        if (/android/i.test(userAgent)) {
            return OS_ANDROID;
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return OS_IOS;
        }
        return OS_UNKNOWN;
    }
    catch (e) {
        return OS_UNKNOWN;
    }
};
export const isIOS = () => OS_IOS === getDeviceOperatingSystem();
export const isAndroid = () => OS_ANDROID === getDeviceOperatingSystem();
//# sourceMappingURL=device.js.map